import { render, staticRenderFns } from "./2DMPRView.vue?vue&type=template&id=1180a08a&scoped=true&"
import script from "./2DMPRView.vue?vue&type=script&lang=js&"
export * from "./2DMPRView.vue?vue&type=script&lang=js&"
import style0 from "./2DMPRView.vue?vue&type=style&index=0&id=1180a08a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1180a08a",
  null
  
)

export default component.exports